import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { SiteLayout } from "@/components/SiteLayout";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

export default function MemberResetPassword() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    if (pw.length < 8) return toast.error(t("passwordMinError"));
    setBusy(true);
    try {
      const r = await api.post("/member/reset-password", { token, password: pw });
      toast.success(r.data.message);
      setDone(true);
      setTimeout(() => { window.location.href = "/member"; }, 1200);
    } catch (e) {
      toast.error(e?.response?.data?.detail || t("resetLinkInvalid"));
    } finally { setBusy(false); }
  };

  return (
    <SiteLayout>
      <div className="mx-auto max-w-md px-5 py-20" data-testid="member-reset-password">
        <h1 className="font-display text-4xl tracking-tighter">{t("resetPasswordTitle")}</h1>
        {!token ? (
          <p className="mt-4 text-sm text-ink-soft" data-testid="reset-no-token">
            {t("resetNoToken")}
          </p>
        ) : done ? (
          <p className="mt-4 text-sm text-ink-soft">{t("resetComplete")}</p>
        ) : (
          <>
            <p className="mt-3 text-sm text-ink-soft">
              {t("resetLinkLifetime")}
            </p>
            <input data-testid="reset-password" type="password" value={pw}
              onChange={(e) => setPw(e.target.value)} placeholder={t("passwordMinPlaceholder")}
              onKeyDown={(e) => e.key === "Enter" && submit()}
              className="mt-6 h-11 w-full rounded-md border border-input bg-white px-3 text-sm" />
            <button data-testid="reset-submit" disabled={busy} onClick={submit}
              className="mt-4 w-full h-12 rounded-full lm-btn-primary text-sm font-semibold disabled:opacity-60">
              {busy ? t("saving") : t("saveNewPassword")}
            </button>
          </>
        )}
      </div>
    </SiteLayout>
  );
}
